import { type RuleType } from '../IRule.ts';
import { CustomWarningsRule } from './custom-warnings/CustomWarnings.rule.ts';
import { DateRangeRule } from './date-range/DateRange.rule.ts';
import { FileTypeRule } from './file-type/FileType.rule.ts';
import { FractionDigitsRule } from './fraction-digits/FractionDigits.rule.ts';
import { IntegerRule } from './integer/Integer.rule.ts';
import { ItemRangeRule } from './item-range/ItemRange.rule.ts';
import { LengthRangeRule } from './length-range/LengthRange.rule.ts';
import { MaxDimensionRule } from './max-dimension/MaxDimension.rule.ts';
import { NeedSignRule } from './need-sign/NeedSign.rule.ts';
import { PositiveRule } from './positive/Positive.rule.ts';
import { RepeatableRangeRule } from './repeatable-range/RepeatableRange.rule.ts';
import { RequiredRule } from './required/Required.rule.ts';
import { TextFormatRule } from './text-format/TextFormat.rule.ts';
import { TotalDigitsRule } from './total-digits/TotalDigits.rule.ts';
import { UniqueFieldRule } from './unique-field-rule/UniqueFieldRule.rule.ts';
import { ValueRangeRule } from './value-range/ValueRange.rule.ts';
import { WhiteSpaceRule } from './white-space/WhiteSpace.rule.ts';

/**
 * Lista di tutte le regole disponibili
 */
export function getAllRuleTypes() {
  return [
    CustomWarningsRule,
    DateRangeRule,
    FileTypeRule,
    FractionDigitsRule,
    IntegerRule,
    ItemRangeRule,
    LengthRangeRule,
    MaxDimensionRule,
    NeedSignRule,
    UniqueFieldRule,
    PositiveRule,
    RepeatableRangeRule,
    RequiredRule,
    TextFormatRule,
    TotalDigitsRule,
    ValueRangeRule,
    WhiteSpaceRule,
  ] as const;
}

// type AllRuleTypes = ReturnType<typeof getAllRuleTypes>;

/**
 * Tipizzazione di tutte le opzioni delle regole disponibili
 */
export type IRulesConfig = Partial<Record<RuleType, Record<string, any>>>;
//   [K in Extract<
//     keyof AllRuleTypes,
//     `${number}`
//   > as AllRuleTypes[K]['type']]?: AllRuleTypes[K]['__optionsType'];
// };
